import { withAppContext } from '@/config/site'
import request from '@/utils/request'

export const fetchCourseTaskPoints = async (payload = {}) => {
  const response = await request('/page/course/task-point/index', {
    data: withAppContext(payload)
  })

  return Array.isArray(response.data) ? response.data : []
}

export const fetchCourseTaskPointDetail = async (id, payload = {}) => {
  const response = await request('/page/course/task-point/detail', {
    data: withAppContext({
      id,
      ...payload
    })
  })

  return response.data || {}
}
